import { useTranslation } from 'react-i18next';

export function usePhotosController() {
  const { t } = useTranslation();

  const tagText = t('charity.about.tag');

  return { tagText };
}
